// Scaled as per 0 to 100.
export const imageAdjustments = [
  { name: "Original", filter: "original", values: [0] },
  {
    name: "Blur",
    filter: "blur",
    value: "1px",
    scale: 1,
    values: [0.5],
    step: 0.01,
    domain: [0, 1],
  },
  {
    name: "Brightness",
    filter: "brightness",
    value: "200%",
    scale: 2,
    values: [0.01],
    step: 0.005,
    domain: [-1, 1],
  },
  {
    name: "Contrast",
    filter: "contrast",
    value: "200%",
    scale: 2,
    values: [0.01],
    step: 0.005,
    domain: [-1, 1],
  },
  {
    name: "HueRotation",
    filter: "huerotation",
    value: "90deg",
    values: [1],
    step: 0.002,
    domain: [-2, 2],
  },
  {
    name: "Saturation",
    filter: "saturation",
    value: "10",
    values: [0.01],
    step: 0.005,
    domain: [-1, 1],
  },
  {
    name: "Grayscale",
    filter: "grayscale",
    value: "100",
    scale: 1,
    values: [1],
    step: 1,
    domain: [0, 3],
  },
  {
    name: "Invert",
    filter: "invert",
    value: "100%",
    values: [0],
    step: 1,
    domain: [0, 1],
  },
  {
    name: "Sepia",
    filter: "sepia",
    value: "100",
    values: [0],
    step: 1,
    domain: [0, 1],
  },
  {
    name: "Vintage",
    filter: "vintage",
    value: "100",
    values: [0],
    step: 1,
    domain: [0, 1],
  },
  {
    name: "Brownie",
    filter: "brownie",
    value: "100",
    values: [0],
    step: 1,
    domain: [0, 1],
  },
  {
    name: "Black/White",
    filter: "blackwhite",
    value: "100",
    values: [0],
    step: 1,
    domain: [0, 1],
  },
  {
    name: "Kodachrome",
    filter: "kodachrome",
    value: "100",
    values: [0],
    step: 1,
    domain: [0, 1],
  },
  {
    name: "Technicolor",
    filter: "technicolor",
    value: "100",
    values: [0],
    step: 1,
    domain: [0, 1],
  },
  {
    name: "Polaroid",
    filter: "polaroid",
    value: "100",
    values: [0],
    step: 1,
    domain: [0, 1],
  },
  {
    name: "Sharpen",
    filter: "sharpen",
    value: "100",
    values: [0],
    step: 1,
    domain: [0, 1],
  },
  {
    name: "Emboss",
    filter: "emboss",
    value: "100",
    values: [0],
    step: 1,
    domain: [0, 1],
  },
];
